import { jsx as _jsx } from "react/jsx-runtime";
import ChevronLeft16 from '@carbon/icons-react/es/chevron--left/16';
import ChevronRight16 from '@carbon/icons-react/es/chevron--right/16';
import contains from 'document.contains';
import { useEffect, useRef, useState } from 'react';
import * as React from 'react';
import { useDistractionFreeMode } from 'hooks/use-distraction-free-mode';
import { Sidebar } from './sidebar';
export const Peel = ({ children, className })=>{
    const [hovered, toggleHovered] = useState(false);
    const { active, enter, exit } = useDistractionFreeMode();
    const [collapsed, toggleCollapsed] = useState(active);
    const triggerRef = useRef(null);
    useEffect(()=>{
        toggleCollapsed(!(!active || hovered));
    }, [
        hovered,
        active
    ]);
    const onMouseMove = (e)=>{
        if (contains(triggerRef.current, e.target)) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        if (active && !hovered) {
            toggleHovered(true);
        }
    };
    const onMouseLeave = ()=>{
        if (active && hovered) {
            toggleHovered(false);
        }
    };
    const onCollapse = ()=>{
        if (active) {
            exit();
        } else {
            enter();
        }
        toggleHovered(active);
    };
    return /*#__PURE__*/ _jsx(Sidebar, {
        theme: "light",
        className: className,
        $pinned: !active,
        collapsed: collapsed,
        trigger: /*#__PURE__*/ _jsx("div", {
            ref: triggerRef,
            children: !active ? /*#__PURE__*/ _jsx(ChevronLeft16, {}) : /*#__PURE__*/ _jsx(ChevronRight16, {})
        }),
        onCollapse: onCollapse,
        onMouseMove: onMouseMove,
        onMouseLeave: onMouseLeave,
        children: children
    });
};
